import { useCallback, useEffect, useState } from 'react';

interface UseResendOTPReturn {
	countdown: number;
	restartCountDown: () => void;
}

export const useCountDown = (initialCountdown?: number): UseResendOTPReturn => {
	const [countdown, setCountdown] = useState(initialCountdown ?? 59);

	const restartCountDown = useCallback(() => {
		setCountdown(initialCountdown ?? 68);
	}, [initialCountdown, setCountdown]);

	useEffect(() => {
		let timer: NodeJS.Timeout;

		if (countdown > 0) {
			timer = setTimeout(() => {
				setCountdown(countdown - 1);
			}, 1000);
		}

		return () => clearTimeout(timer);
	}, [countdown]);

	return {
		countdown,
		restartCountDown,
	};
};
